import { render, staticRenderFns } from "./SettingsNotifications.vue?vue&type=template&id=48defc32&scoped=true&"
import script from "./SettingsNotifications.vue?vue&type=script&lang=js&"
export * from "./SettingsNotifications.vue?vue&type=script&lang=js&"
import style0 from "./SettingsNotifications.vue?vue&type=style&index=0&id=48defc32&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48defc32",
  null
  
)

export default component.exports